import { EnvironmentConst } from '../components/planner-edit/constants/Environment.const';

export const PlannerConstants = {
    appEnvList: [EnvironmentConst.MobileApps.id, EnvironmentConst.MobileWeb.id, EnvironmentConst.ConnectedTVApp.id],
    BUDGET_LIMIT: 13,
    ACTIVATION_BUDGET_LIMIT:150,
    ACTIVATION_ADVERTISER_ID:64500618
};
